// extracted by mini-css-extract-plugin
module.exports = {"container":"ManageReserve_container__SDbY5","header":"ManageReserve_header__xJ88N","body":"ManageReserve_body__CmPjW","box":"ManageReserve_box__39vOk"};